import React, { useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core";
import { useEditor } from "@tldraw/tldraw";

const BackgroundComponent = ({ setIdFromat, setIsShowCustomStylePanel }) => {
  const classes = useStyles();
  const [selectedSide, setSelectedSide] = useState();
  const editor = useEditor();

  // Move this to a function to get the latest shape on every render
  const getShape = (side) => editor.getShape(side);

  const onHandleChangeBg = useCallback(
    (side) => {
      const shape = getShape(side);
      setIdFromat(side);

      if (editor.inputs.ctrlKey || editor.inputs.shiftKey) {
        const isSelected = editor.getSelectedShapeIds().includes(side);
        if (isSelected) {
          editor.deselect(shape);
          setIsShowCustomStylePanel(false);
        } else {
          editor.select(...editor.getSelectedShapes(), shape);
        }
      } else {
        editor.select(shape);
        setIsShowCustomStylePanel(true);
      }
    },
    [editor, setIdFromat, setIsShowCustomStylePanel]
  );

  const handleClick = (side) => {
    setSelectedSide(side);
    setIdFromat(side);
    onHandleChangeBg(side);
  };

  return (
    <div>
      <h2 className={classes.title}>Background</h2>
      <p className={classes.description}>Click on a side to change its background color</p>
      <div className={classes.optionContainer}>
        <div
          className={`${classes.option} ${selectedSide === "shape:front" ? classes.selectedOption : ""}`}
          onClick={() => handleClick("shape:front")}
          title="Click to change front side background color"
        >
          <span className={classes.iconContainer}>🎨</span>
          <span className={classes.optionText}>Front side</span>
          <span className={classes.clickHint}>Click to edit</span>
        </div>
        <div
          className={`${classes.option} ${selectedSide === "shape:back" ? classes.selectedOption : ""}`}
          onClick={() => handleClick("shape:back")}
          title="Click to change back side background color"
        >
          <span className={classes.iconContainer}>🎨</span>
          <span className={classes.optionText}>Back side</span>
          <span className={classes.clickHint}>Click to edit</span>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  title: {
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    marginBottom: "8px",
    color: "#0C172C",
    marginLeft: "3px",
  },
  description: {
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    marginBottom: "12px",
    color: "#6B7280",
    marginLeft: "3px",
  },
  optionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  option: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    borderRadius: "8px",
    backgroundColor: "#F9F9FF",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    color: "#00112B",
    transition: "all 0.3s ease",
    border: "2px solid transparent",
    "&:hover": {
      backgroundColor: "#E2E2FC",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      "& $clickHint": {
        opacity: 1,
      },
    },
  },
  selectedOption: {
    backgroundColor: "#E2E2FC",
    borderColor: "#4F46E5",
    boxShadow: "0 2px 8px rgba(79, 70, 229, 0.2)",
  },
  iconContainer: {
    fontSize: "18px",
    marginRight: "8px",
    display: "flex",
    alignItems: "center",
  },
  optionText: {
    flex: 1,
    fontSize: "14px",
    fontWeight: "500",
  },
  clickHint: {
    fontSize: "11px",
    color: "#6B7280",
    fontWeight: "400",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },
});

export const BG = React.memo(BackgroundComponent);
